<template>
  <div class="form-group">
    <!-- <label>Address Search:</label>
    <input type="text" class="form-control" ref="addressBox" id="search-input" placeholder="Type address..." /> -->

    <!-- <label><v-icon>mdi-magnify</v-icon> Address Search: </label> -->
    <label
      ><v-icon>mdi-magnify</v-icon>
      <v-select
        v-model="selectedType"
        class="district-type-selector"
        :items="searchType"
        label="District Type"
        solo
        dense
        height="20"
      ></v-select>
    </label>
    <v-text-field
    v-show="selectedType === 'Address' "
      label="Address"
      
      dense
      fullWidth
      placeholder=""
      id="search-input"
      ref="addressBox"
      @blur="calculateTextSearchWidth(false)"
      @click="calculateTextSearchWidth(true)"
      v-model="addressString"
    ></v-text-field>
    <APISearch v-show="selectedType !== 'Address' && selectedType.value !== 'Address'"/>
  </div>
</template>
<script>
import { Loader } from "google-maps";
import { Config, Enums } from "../../../data/Config/Config";
import APISearch from "./APISearch";
//import fetch from 'node-fetch';
import { EventBus } from "../../../data/EventBus";
export default {
  name: "AddressSearch",
  components: {
      APISearch
  },
  data: function () {
    return {
      searchBox: null,
      addressString: "",
      windowWidth: window.innerWidth,
      selectedType: "Address",
      searchType: [
        { text: "Address", value: "Address" },
        { text: "US Congress", value: Enums.LEG_BODY.CONGRESS },
        { text: "State Upper House", value: Enums.LEG_BODY.ST_UPPER },
        { text: "State Lower House", value: Enums.LEG_BODY.ST_LOWER },
      ],
    };
  },
  mounted: function () {
    if (typeof google === "undefined") this.init();

    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });

    EventBus.$on('change-search',(val)=>this.selectedType = val);
  },
  watch: {
    selectedAddress: function (val) {
      if (typeof val.name === "undefined" || !val.name) {
        this.addressString = "";
      }
    },
    selectedType: function (val){
       if (
          val === Enums.LEG_BODY.CONGRESS ||
          val === Enums.LEG_BODY.ST_UPPER ||
          val === Enums.LEG_BODY.ST_LOWER
        ) {
          this.$store.commit("setDistrictType", val);
        }
    }
  },
  computed: {
    selectedAddress: {
      get: function () {
        return this.$store.getters.getSelectedAddress;
      },
    },
  },
  methods: {
    calculateTextSearchWidth(_selected) {
      if (_selected) {
        this.$refs.addressBox.$el.style.width = "300px";
        this.$refs.addressBox.$el.style.marginTop = "5%";
      } else {
        if (this.$refs.addressBox.value.length === 0) {
          this.$refs.addressBox.$el.style.width = "";
          this.$refs.addressBox.$el.style.marginTop = "5%";
        }
      }
    },
    setSearchBounds() {
      if (this.searchBox) {
        this.searchBox.setBounds();
      }
    },
    async init() {
      const loader = new Loader(Config.api.keys.GoogleKey, {
        libraries: ["places"],
      });

      const google = await loader.load();
      const input = document.getElementById("search-input");
      this.searchBox = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: "us" },
      });

      this.searchBox.addListener("place_changed", () => {
        const place = this.searchBox.getPlace();
        if (!place) return;
        const loc = place.geometry.location;

        EventBus.$emit('select-from-address', [loc.lng(),loc.lat()])

        // this.$store.commit("setSelectedPoint", {
        //   lngLat: {
        //     lng: loc.lng(),
        //     lat: loc.lat(),
        //   },
        // });

        this.$store.commit("setSelectedAddress", place);
      });
    },
  },
};
</script>
<style scoped>
.v-toolbar .v-input {
  margin-top: 10%;
  display: inline-block;
  caret-color: black;
}


.district-type-selector {
  max-width: 210px;
}

.form-group{
      white-space: nowrap;
}
</style>